import {
  Component,
  OnInit,
  HostListener,
  ElementRef,
  Input,
  ViewChild,
  Inject,
  AfterContentInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-form-file-selection',
  templateUrl: './form-file-selection.component.html',
  styleUrls: ['./form-file-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormFileSelectionComponent,
      multi: true,
    },
  ],
})
export class FormFileSelectionComponent implements OnInit, ControlValueAccessor {
  // @Input() maxFiles = 1;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Input() accept: string;
  @Input() displayFilename: boolean;
  @ViewChild('fileSelection') fileSelection;
  @ViewChild('btn') btn;

  files: File[] = [];
  onChange: (files: File[]) => void;

  constructor(
    private host: ElementRef<HTMLInputElement>,
    private snackBar: MatSnackBar
  ) {
    // console.warn(this.data);
    // if (!!this.data) {
    // this.files = this.data;
    // this.
    // }
  }

  ngOnInit() {}

  writeValue(obj: File[]): void {
    // clear file input
    this.host.nativeElement.value = '';
    this.files = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  addFiles(newfiles: File[]) {
    if (!this.files) {
      this.files = [];
    }
    const MAX = 25 * 1024 * 1024;
    const valid = newfiles.filter(f => (f && f.size ? f.size < MAX : true));
    const invalid = newfiles.filter(f => (f && f.size ? f.size >= MAX : false));

    if (invalid.length) {
      this.snackBar.open('One or more files exceed the 25MB size limit and cannot be uploaded.', 'Close', {
        duration: 6000,
      });
    }

    if (!valid.length) {
      return;
    }

    this.files = [...this.files, ...valid];
    this.onChange(this.files);
  }

  addFilesClick() {
    this.fileSelection.nativeElement.click();
  }

  changeListener(event: Event) {
    const element = event.currentTarget as HTMLInputElement;

    const files = element.files;

    this.addFiles(Array.from(files));

    this.change.emit(event);
  }
}
